import React, { createContext, useEffect, useState } from "react";
import { FormProvider } from "react-hook-form";
import { useFundActionPlan } from "../hooks/useFundActionPlan";
import { Grid } from "@mui/material";
import { ConvertDateToUnixOrNull, DefaultArrayEmpty, I18n, getMonthDifference } from "utilities/utilities";
import DateRangeFund from "../components/DateRange";
import InputNumberItem from "components/Input/InputNumber";
import { BtnAdd, BtnDelete } from "components/Button/ButtonAll";
import moment from "moment";

const FundActionPlanDuration = createContext(null);

export default function FundActionPlanFormDuration(props) {
    const {
        formDuration,
        onAddDuration,
        onDeleteDuration,
        arrDuration,
        nProjectCurrent,
        dataRowProject,
        nTrigger,
        nMaxMonth,
        nMinMonth,
        setNMaxMonthDueDate,
        setNMinMonthDueDate,
        nMinMonthDueDate,
        nMaxMonthDueDate,
        isSubActivity,
        nMaxWeightActivity,
        nParentID
    } = props;

    const {
        DialogFn
    } = useFundActionPlan();

    const [isNew, setIsNew] = useState(true);

    const objProvider = React.useMemo(() => (
        {
            setIsNew,
        }
    ), []);

    const handleChangeWeight = (nID) => {
        let clone = [...dataRowProject];

        let lstData = [].concat(...clone.map(m => m.lstChildren)).filter(f => parseInt(f.nProjectID) === parseInt(nProjectCurrent));
        let lstActivity = [].concat(...lstData.map(m => m.lstActivity));
        let nActivityID = [].concat(...lstActivity.map(m => m.lstDuration)).find(f => f.nID === nID)?.nActivityID;
        let nMaxWeight = 100;

        if (nActivityID) {
            lstActivity = lstActivity.filter(f => f.nID !== nActivityID);
        }

        let nWeight = lstActivity.filter(f => f.nParentID === null).map(m => parseFloat(m.sWeight) || 0).reduce((a, b) => a + b, 0);
        let nSum = nWeight;

        if (nMaxWeight && isSubActivity) {
            nMaxWeight = lstActivity.filter(f => f.nActivityID === nParentID).map(m => parseFloat(m.sWeight) || 0).reduce((a, b) => a + b, 0);
            nSum = lstActivity.filter(f => f.nParentID === nParentID).map(m => parseFloat(m.sWeight) || 0).reduce((a, b) => a + b, 0);;
        }

        arrDuration.forEach(f => {
            let nDiff = moment(formDuration.getValues("sEndMonth_" + f.nID)).diff(moment(formDuration.getValues("sStartMonth_" + f.nID)), "month");
            let nWeight = 0;
            let sWeight = formDuration.getValues("sWeight_" + f.nID);
            if (!isNaN(nDiff) && sWeight) {
                nWeight = parseFloat(sWeight) * (nDiff + 1);
            }

            nSum += nWeight;
        });


        if (nSum > nMaxWeight) {
            DialogFn.Warning(I18n.SetText("FundPlan.OverWeight") + nMaxWeight, () => {
                formDuration.setValue(`sWeight_${nID}`, null);
            }, () => {
                formDuration.setValue(`sWeight_${nID}`, null);
            });

        }
    }

    const OnCheckDuplicate = (date, clone) => {
        let isDuplicate = false;

        clone.forEach(item => {

            let start = moment(formDuration.getValues("sStartMonth_" + item.nID)).startOf("month");
            let end = moment(formDuration.getValues("sEndMonth_" + item.nID)).endOf("month");

            if (start.isValid && end.isValid) {
                let isBetween = date.isBetween(start, end, "month", "[]");
                if (isBetween) {
                    isDuplicate = true;
                    return true;
                }
            }
        });

        return isDuplicate;
    }

    const handleOnChange = (e, nID, type) => {
        let isDuplicate = false;
        let clone = [...arrDuration].filter(f => f.nID !== nID);

        if (e) {
            let date = type === "start" ? moment(e).startOf("month") : moment(e).endOf("month");

            isDuplicate = OnCheckDuplicate(date, clone);
            handleChangeWeight(nID);

            if (isDuplicate) {
                DialogFn.Warning(I18n.SetText("FundPlan.DuplicateDuration"));
                if (type === "start") {
                    formDuration.setValue("sStartMonth_" + nID, null);
                } else {
                    formDuration.setValue("sEndMonth_" + nID, null);
                }
            } else if (nMaxMonth && nMinMonth) {    //check min max month

                let dStartMonth = moment(nMinMonth).startOf("month");
                let dEndMonth = moment(nMaxMonth).startOf("month");

                let start = moment(formDuration.getValues("sStartMonth_" + nID)).startOf("month").year(dStartMonth.year());
                let end = moment(formDuration.getValues("sEndMonth_" + nID)).endOf("month").year(dStartMonth.year());

                let isBetweenStart = start.isBetween(dStartMonth, dEndMonth, "month", "[]");
                let isBetweenEnd = end.isBetween(dStartMonth, dEndMonth, "month", "[]");

                if (!isBetweenStart && type === "start") {
                    DialogFn.Warning(I18n.SetText("FundPlan.OverDurationRange"));
                    formDuration.setValue("sStartMonth_" + nID, null);
                } else if (!isBetweenEnd && type === "end") {
                    DialogFn.Warning(I18n.SetText("FundPlan.OverDurationRange"));
                    formDuration.setValue("sEndMonth_" + nID, null);
                }
            }

            let nDate = ConvertDateToUnixOrNull(date);
            if (type === "start") {
                if (nDate < nMinMonthDueDate) {
                    setNMinMonthDueDate(nDate);
                }

            } else if (nDate > nMaxMonthDueDate) {
                setNMaxMonthDueDate(nDate);
            }
        }
    }

    return (
        <FundActionPlanDuration.Provider
            value={objProvider}
        >
            <FormProvider {...formDuration}>
                <Grid container spacing={2}>
                    {/* Duration */}
                    {DefaultArrayEmpty(arrDuration).map((m, i) => (
                        <Grid item container spacing={2} key={"key_duration_" + m.nID}>
                            <Grid item xs={12} md={7}>
                                <DateRangeFund
                                    NameStart={`sStartMonth_${m.nID}`}
                                    NameEnd={`sEndMonth_${m.nID}`}
                                    LabelStart={I18n.SetText("FundPlan.StartMonth")}
                                    LabelEnd={I18n.SetText("FundPlan.EndMonth")}
                                    IsMonthPicker
                                    nID={m.nID}
                                    required
                                    isDisableYear
                                    nYearMapper={props.nYear}
                                    onChange={handleOnChange}
                                    nTrigger={nTrigger}
                                />
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <InputNumberItem
                                    name={`sWeight_${m.nID}`}
                                    label={I18n.SetText("FundPlan.WeightMonth")}
                                    max={100}
                                    type={"Number"}
                                    maxDigits={2}
                                    required
                                    onChange={() => { handleChangeWeight(m.nID) }}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <Grid container spacing={2}>
                                    {DefaultArrayEmpty(arrDuration).length === i + 1 &&
                                        <Grid item>
                                            <BtnAdd
                                                sColor="#00B393"
                                                sColorHover="#009278"
                                                id="AddDuration"
                                                txt={I18n.SetText("FundPlan.AddDuration")}
                                                IsCircleWithOutText
                                                onClick={formDuration.handleSubmit(onAddDuration, (err) => {
                                                    document.getElementById(Object.keys(err)[0])?.focus();
                                                })}
                                            />
                                        </Grid>
                                    }
                                    {DefaultArrayEmpty(arrDuration).length > 1 &&
                                        <Grid item>
                                            <BtnDelete
                                                sColorHover="#d30d1e"
                                                id="DeleteDuration"
                                                IsCircleWithOutText
                                                onClick={() => onDeleteDuration(m.nID)}
                                            />
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </FormProvider>
        </FundActionPlanDuration.Provider>
    )
}